<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <Header class="mb-5" />

    <div class="d-flex justify-center">
      <div class="guide elevation-5 rounded mr-10" ref="guide">
        <div
          class="
            text-center
            pa-1
            body-1
            font-weight-medium
            primary--text
            camera-header
          "
        >
          {{ $t('guide') }}
        </div>

        <div
          class="track-msg white--text body-1 text-center"
          v-if="guideConnected && !guideVideoState"
        >
          {{ $t('guideCameraOff') }}
        </div>

        <div class="track-msg body-1 text-center" v-if="!guideConnected">
          {{ $t('guideNotConnected') }}
        </div>
      </div>

      <div class="school elevation-5 rounded" ref="school">
        <div
          class="
            text-center
            pa-1
            body-1
            font-weight-medium
            primary--text
            camera-header
          "
        >
          {{ $t('school') }}
        </div>

        <div
          class="track-msg white--text body-1 text-center"
          v-if="schoolConnected && !schoolVideoState"
        >
          {{ $t('schoolCameraOff') }}
        </div>

        <div class="track-msg body-1 text-center" v-if="!schoolConnected">
          {{ $t('schoolNotConnected') }}
        </div>
      </div>
    </div>

    <Buttons class="mt-5" />

    <v-dialog
      v-model="showUnlockMediaDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-text class="pt-5 body-1 justify-center">
          {{ $t('enableMediaDescription') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center">
          <v-btn
            color="primary"
            :lang="$i18n.locale"
            @click="unlockMedia"
          >
            {{ $t('enable') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Header from "@/views/shadow/Header";
import Buttons from "@/views/shadow/Buttons";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Header,
    Buttons,
  },
  computed: {
    ...mapState({
      triggersetListeners: (state) => state.twilio.triggersetListeners,
      guideConnected: (state) => state.twilio.guideConnected,
      schoolConnected: (state) => state.twilio.schoolConnected,
      guideVideoState: (state) => state.twilio.guideVideoState,
      schoolVideoState: (state) => state.twilio.schoolVideoState,
      allowLeave: (state) => state.shadow.allowLeave,
      mediaUnlocked: (state) => state.shadow.mediaUnlocked
    }),
    showUnlockMediaDialog() {
      return !this.mediaUnlocked;
    }
  },
  mounted() {
    this.changeRefs({
      guide: this.$refs.guide,
      school: this.$refs.school,
    });

    if (!this.triggersetListeners) this.setTriggersetListeners();
  },
  methods: {
    ...mapActions(["changeRefs", "detachTracks"]),
    ...mapMutations(["setTriggersetListeners", "setAllowLeave", "setMediaUnlocked"]),
    async unlockMedia() {
      this.setMediaUnlocked(true);
    }
  },
  destroyed() {
    this.detachTracks();
  },
  beforeRouteLeave(to, from, next) {
    if (this.allowLeave) {
      this.setAllowLeave(false);
      next();
    } else {
      next(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.camera-header {
  border-bottom: 1px solid #eee;
}
</style>